export const marzoLines = [
  {
    id: 'altis',
    label: 'Altis',
    icon: 'ri-building-line',
    description: 'Elegância, arrojo e sofisticação, próprios de espaços corporativos que pedem mais personalidade.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=17&altis',
    image: 'https://www.marzovitorino.com.br/imgs/altis-home.jpg',
    products: [
      { name: 'Altis 1', image: 'https://www.marzovitorino.com.br/imgs/altis-.jpg' },
      { name: 'Altis 2', image: 'https://www.marzovitorino.com.br/imgs/altis-928757_240506103158.jpg' },
      { name: 'Altis 3', image: 'https://www.marzovitorino.com.br/imgs/altis-5be557_240506103158.jpg' },
      { name: 'Altis 4', image: 'https://www.marzovitorino.com.br/imgs/altis-ada6bc_240506103158.jpg' },
    ],
  },
  {
    id: 'terios',
    label: 'Térios',
    icon: 'ri-briefcase-4-line',
    description: 'Estilo marcante que eleva o patamar do ambiente de trabalho.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=16&terios',
    image: 'https://www.marzovitorino.com.br/imgs/terios-home.jpg',
    products: [
      { name: 'Térios 1', image: 'https://www.marzovitorino.com.br/imgs/terios-completa.jpg' },
      { name: 'Térios 2', image: 'https://www.marzovitorino.com.br/imgs/terios-completa-.jpg' },
    ],
  },
  {
    id: 'attuale',
    label: 'Attuale',
    icon: 'ri-layout-masonry-line',
    description: 'Conforto e organização que fazem a diferença no dia a dia de trabalho.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=3&attuale',
    image: 'https://www.marzovitorino.com.br/imgs/attualehomedesktop.jpg',
    products: [
      { name: 'Attuale 1', image: 'https://www.marzovitorino.com.br/imgs/attuale341440_231018115521.jpg' },
      { name: 'Attuale 2', image: 'https://www.marzovitorino.com.br/imgs/attualec6f154_231018115521.jpg' },
      { name: 'Attuale 3', image: 'https://www.marzovitorino.com.br/imgs/attuale360ad3_231018115521.jpg' },
      { name: 'Attuale 4', image: 'https://www.marzovitorino.com.br/imgs/attuale07dde7_231018115521.jpg' },
    ],
  },
  {
    id: 'euro',
    label: 'Euro',
    icon: 'ri-archive-drawer-line',
    description: 'Móveis de aço com inovação agregada. Mais segurança e modernidade!',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=9&euro',
    image: 'https://www.marzovitorino.com.br/imgs/eurohomedesktop.jpg',
    products: [
      { name: 'Euro 1', image: 'https://www.marzovitorino.com.br/imgs/euro8cf76c_231018115558.jpg' },
      { name: 'Euro 2', image: 'https://www.marzovitorino.com.br/imgs/euro0ab2f7_231018115558.jpg' },
      { name: 'Euro 3', image: 'https://www.marzovitorino.com.br/imgs/euro4b1e04_231018115558.jpg' },
      { name: 'Euro 4', image: 'https://www.marzovitorino.com.br/imgs/euro6a0e8a_231018115558.jpg' },
    ],
  },
  {
    id: 'imperia',
    label: 'Impéria Premium',
    icon: 'ri-vip-crown-line',
    description: 'Requinte e soluções que atendem as mais diversificadas demandas de espaços corporativos.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=8&imperia-premium',
    image: 'https://www.marzovitorino.com.br/imgs/imperia-home.jpg',
    products: [
      { name: 'Impéria 1', image: 'https://www.marzovitorino.com.br/imgs/imp.jpg' },
      { name: 'Impéria 2', image: 'https://www.marzovitorino.com.br/imgs/imperia824291_231018115420.jpg' },
      { name: 'Impéria 3', image: 'https://www.marzovitorino.com.br/imgs/imperiac58ae1_231018115420.jpg' },
      { name: 'Impéria 4', image: 'https://www.marzovitorino.com.br/imgs/imperia59653c_231018115420.jpg' },
    ],
  },
  {
    id: 'make',
    label: 'Make',
    icon: 'ri-pencil-ruler-2-line',
    description: 'Feita para dar um toque moderno e arrojado a escritórios que prezam por flexibilidade.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=7&make',
    image: 'https://www.marzovitorino.com.br/imgs/5eb2a3_250708094033.png',
    products: [
      { name: 'Make 1', image: 'https://www.marzovitorino.com.br/imgs/make-82b9db_250708094217.png' },
      { name: 'Make 2', image: 'https://www.marzovitorino.com.br/imgs/make-aec384_250708094218.png' },
      { name: 'Make 3', image: 'https://www.marzovitorino.com.br/imgs/make-9929ff_250708094218.png' },
      { name: 'Make 4', image: 'https://www.marzovitorino.com.br/imgs/make918bc0_231018115656.jpg' },
    ],
  },
  {
    id: 'prima-arq',
    label: 'Prima Arq',
    icon: 'ri-draft-line',
    description: 'Moderna e sofisticada, detalhes que dão aquele toque especial ao ambiente.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=6&prima-arq',
    image: 'https://www.marzovitorino.com.br/imgs/b25f56_250708093831.png',
    products: [
      { name: 'Prima Arq 1', image: 'https://www.marzovitorino.com.br/imgs/prima-arq-5662f6_250708094737.png' },
      { name: 'Prima Arq 2', image: 'https://www.marzovitorino.com.br/imgs/prima-arq-7e81ae_250708094737.png' },
      { name: 'Prima Arq 3', image: 'https://www.marzovitorino.com.br/imgs/prima-arq-3dd3cc_250708094737.png' },
      { name: 'Prima Arq 4', image: 'https://www.marzovitorino.com.br/imgs/prima-arq-844559_250708094737.png' },
    ],
  },
  {
    id: 'prima-clean',
    label: 'Prima Clean',
    icon: 'ri-contrast-drop-line',
    description: 'Leveza e elegância que proporcionam ambientes clean e charmosos.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=5&prima-clean',
    image: 'https://www.marzovitorino.com.br/imgs/4a0e30_250708093905.png',
    products: [
      { name: 'Prima Clean 1', image: 'https://www.marzovitorino.com.br/imgs/prima-clean-736c39_250708094459.png' },
      { name: 'Prima Clean 2', image: 'https://www.marzovitorino.com.br/imgs/primaclean642671_231018115856.jpg' },
      { name: 'Prima Clean 3', image: 'https://www.marzovitorino.com.br/imgs/primaclean2d27b8_231018115856.jpg' },
      { name: 'Prima Clean 4', image: 'https://www.marzovitorino.com.br/imgs/prima-clean-balrec-7ab20e_250708094459.png' },
    ],
  },
  {
    id: 'prima-impact',
    label: 'Prima Impact',
    icon: 'ri-flashlight-line',
    description: 'Robustez e sofisticação que dão personalidade aos escritórios.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=4&prima-impact',
    image: 'https://www.marzovitorino.com.br/imgs/5e9744_250708093926.png',
    products: [
      { name: 'Prima Impact 1', image: 'https://www.marzovitorino.com.br/imgs/primaimpact.jpg' },
      { name: 'Prima Impact 2', image: 'https://www.marzovitorino.com.br/imgs/prima-impacta8dbf2_250708094858.png' },
      { name: 'Prima Impact 3', image: 'https://www.marzovitorino.com.br/imgs/primaimpactjpg0e02ec_231018120005.jpg' },
      { name: 'Prima Impact 4', image: 'https://www.marzovitorino.com.br/imgs/primaimpactjpg888441_231018120005.jpg' },
    ],
  },
  {
    id: 'refeitorio',
    label: 'Refeitório',
    icon: 'ri-restaurant-line',
    description: 'Resistência, beleza e aproveitamento de espaço nos ambientes de refeições.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=2&refeitorios',
    image: 'https://www.marzovitorino.com.br/imgs/ref-home-desktop.jpg',
    products: [
      { name: 'Refeitório 1', image: 'https://www.marzovitorino.com.br/imgs/refeitorio.jpg' },
      { name: 'Refeitório 2', image: 'https://www.marzovitorino.com.br/imgs/refeitorio3325b7_231018015930.jpg' },
      { name: 'Refeitório 3', image: 'https://www.marzovitorino.com.br/imgs/refeitorioc5667d_231018015930.jpg' },
      { name: 'Refeitório 4', image: 'https://www.marzovitorino.com.br/imgs/refeitorio0b8353_231018015930.jpg' },
    ],
  },
  {
    id: 'romanzza',
    label: 'Romanzza Plus',
    icon: 'ri-sofa-line',
    description: 'Projetada para oferecer o máximo de funcionalidade e conforto.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=10&romanzza-plus',
    image: 'https://www.marzovitorino.com.br/imgs/romannzahomedesktop.jpg',
    products: [
      { name: 'Romanzza 1', image: 'https://www.marzovitorino.com.br/imgs/romanzza.jpg' },
      { name: 'Romanzza 2', image: 'https://www.marzovitorino.com.br/imgs/romanzza65bda0_231018020031.jpg' },
      { name: 'Romanzza 3', image: 'https://www.marzovitorino.com.br/imgs/romanzza63ede8_231018020031.jpg' },
      { name: 'Romanzza 4', image: 'https://www.marzovitorino.com.br/imgs/romanzza4137ae_231018020031.jpg' },
    ],
  },
  {
    id: 'smart',
    label: 'Smart',
    icon: 'ri-lightbulb-line',
    description: 'Praticidade e flexibilidade. Ideal para ambientes de treinamentos.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=11&smart',
    image: 'https://www.marzovitorino.com.br/imgs/smarthomedesktop.jpg',
    products: [
      { name: 'Smart 1', image: 'https://www.marzovitorino.com.br/imgs/smart.jpg' },
      { name: 'Smart 2', image: 'https://www.marzovitorino.com.br/imgs/smartd9c34f_231018020132.jpg' },
      { name: 'Smart 3', image: 'https://www.marzovitorino.com.br/imgs/smart0b97ad_231018020132.jpg' },
    ],
  },
  {
    id: 'telemarketing',
    label: 'Telemarketing',
    icon: 'ri-headphone-line',
    description: 'Soluções que contam com tratamento acústico e conforto ergonômico.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=12&call-center-telemarketing',
    image: 'https://www.marzovitorino.com.br/imgs/telemarketinghomedesktop.jpg',
    products: [
      { name: 'Telemarketing 1', image: 'https://www.marzovitorino.com.br/imgs/telemarketing.jpg' },
    ],
  },
  {
    id: 'uno',
    label: 'Uno',
    icon: 'ri-price-tag-3-line',
    description: 'Custo benefício com um toque de elegância.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=13&uno',
    image: 'https://www.marzovitorino.com.br/imgs/unohomedesktop.jpg',
    products: [
      { name: 'Uno 1', image: 'https://www.marzovitorino.com.br/imgs/uno.jpg' },
      { name: 'Uno 2', image: 'https://www.marzovitorino.com.br/imgs/unob6f59f_231018020702.jpg' },
      { name: 'Uno 3', image: 'https://www.marzovitorino.com.br/imgs/uno0b6ef7_231018020702.jpg' },
    ],
  },
  {
    id: 'work-pro',
    label: 'Work Pro',
    icon: 'ri-computer-line',
    description: 'Inovação e tecnologia para escritórios modernos e versáteis.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=14&work-pro',
    image: 'https://www.marzovitorino.com.br/imgs/workpro-home.jpg',
    products: [
      { name: 'Work Pro 1', image: 'https://www.marzovitorino.com.br/imgs/work.jpg' },
      { name: 'Work Pro 2', image: 'https://www.marzovitorino.com.br/imgs/workprodfaea7_231018020753.jpg' },
      { name: 'Work Pro 3', image: 'https://www.marzovitorino.com.br/imgs/workpro9e6189_231018020753.jpg' },
      { name: 'Work Pro 4', image: 'https://www.marzovitorino.com.br/imgs/workpro3f46ab_231018020753.jpg' },
    ],
  },
  {
    id: 'tomadas',
    label: 'Tomadas',
    icon: 'ri-plug-line',
    description: 'Inovação, praticidade e sofisticação para conectividade no ambiente de trabalho.',
    url: 'https://www.marzovitorino.com.br/produto.php?produto=15&tomadas',
    image: 'https://www.marzovitorino.com.br/imgs/tomadashomedesktop.jpg',
    products: [
      { name: 'Tomadas 1', image: 'https://www.marzovitorino.com.br/imgs/tomadas.jpg' },
      { name: 'Tomadas 2', image: 'https://www.marzovitorino.com.br/imgs/tomadasf48a89_231018020839.jpg' },
      { name: 'Tomadas 3', image: 'https://www.marzovitorino.com.br/imgs/tomadasbc06e5_231018020839.jpg' },
      { name: 'Tomadas 4', image: 'https://www.marzovitorino.com.br/imgs/tomadasab79ac_231018020839.jpg' },
    ],
  },
];
